import { is, List } from "immutable";
import * as React from "react";
import { connect } from "react-redux";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import * as redux from "redux";
import { EditTypeForm } from "./EditTypeForm";
import * as Actions from "../../../actions";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import { ErrorCodes } from "../../../domain";
import * as Forms from "../../../forms";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";
import { Utility } from "../../../utils";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
    templates: state.adminEmailTemplates.templates,
    types: state.adminAbstractType.types,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
    loadTemplates: () => dispatch(Actions.AdminEmailTemplate.loadTemplates()),
    updateType: (type: M.Abstract.AbstractTypeEdit) => dispatch(Actions.AdminAbstractType.updateType(type)),
});

type OwnProps = RouteComponentProps<{
    typeId: string;
}> & {
    eventId: number;
};

type ConnectedState = Comp.Base.DefaultConnectedState & {
    templates: List<M.Email.EmailTemplate>;
    types: List<M.Abstract.AbstractTypeEdit>;
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
    loadTemplates: () => void;
    updateType: (type: M.Abstract.AbstractTypeEdit) => void;
};

interface OwnState {
    lastPath: string;
    type?: M.Abstract.AbstractTypeEdit;
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class EditTypeComponent extends Comp.Base.BaseComponent<CombinedProps, OwnState> {

    private form: EditTypeForm | null = null;

    public constructor(props: CombinedProps) {
        super(props);

        this.state = {
            lastPath: props.lastPath && props.lastPath !== Utility.getRelativePath()
                ? props.lastPath
                : Paths.AdminAbstractList(props.eventId),
        };
    }

    public async componentDidMount() {
        this._isMounted = true;
        const templateId = this.getRecordId();
        await this.loadTypeFromState(true);

        if (templateId > 0)
            this.loadType();

        this.props.loadTemplates();
    }

    public componentDidUpdate(prevProps: Readonly<CombinedProps>) {
        if (!is(prevProps.types, this.props.types))
            this.loadTypeFromState();
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        const type = this.state.type;
        const typeId = this.getRecordId();
        const loading = this.state.loading; // !!this.props.loadingType[typeId];
        // const listLink = this.lastPathIsFromListView()
        //     ? <a href="#" onClick={(e) => { ReactHelper.emptyClickHandler(e); window.history.back(); }}>Abstracts</a>
        //     : <Link to={Paths.AdminEmailTemplate.List}>Abstracts</Link>;

        const cancelLink = <Link to={this.state.lastPath}>Cancel</Link>;

        const cancelWrap = <Comp.Generic.WrapperLess>
            {cancelLink}
        </Comp.Generic.WrapperLess>;

        return <Comp.Page.AdminPage title={"Abstracts"}>

            {this.getErrorAlert()}

            <Comp.Generic.LoadingSpinner show={loading} />

            <h1>
                {typeId === 0 ? "Add new abstract type" : `Edit ${type ? type.name : "abstract type"}`}
            </h1>

            <EditTypeForm
                api={this.props.api}
                cancelLink={cancelWrap}
                emailTemplates={this.props.templates}
                eventId={this.props.eventId}
                onSubmit={(model, body) => this.onSubmit(model, body)}
                ref={(ref: any) => this.form = ref}
            />

        </Comp.Page.AdminPage>;
    }

    private getRecordId(props?: Readonly<CombinedProps>) {
        return parseInt(props
            ? props.match.params.typeId
            : this.props.match.params.typeId, 10);
    }

    // private lastPathIsFromListView() {
    //     const lastPath = this.props.lastPath;
    //     const path = Paths.AdminEmailTemplate.List;
    //     return lastPath && (lastPath === path || lastPath.indexOf(`${path}?`) === 0);
    // }

    private async loadType() {
        const id = this.getRecordId();
        const result = await this.props.api.get(Api.endpoints.admin.abstractType.type.withUrlParams({ id }));

        if (!this._isMounted)
            return;

        this.toggleLoading(false);

        if (result.isSuccess && result.data)
            this.props.updateType(result.data);
        else if (result.errorCode === ErrorCodes.NotFound.id) {
            this.props.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />"));
            this.props.goto(Paths.AdminAbstractList(this.props.eventId));
        }
        else
            this.setErrors(M.Result.Result.errorsOrMessage(result));
    }

    private async loadTypeFromState(isInitialCheck?: boolean) {
        const typeId = this.getRecordId();
        const type = this.props.types.find((x: M.Abstract.AbstractTypeEdit) => x.id === typeId);

        if (type) {
            if (type.eventId !== this.props.eventId) {
                this.props.goto(Paths.AdminAbstractTypeEdit(type.eventId, type.id));
                return;
            }

            await this.setStateAsync({ ...this.state, type });
            if (this.form)
                this.form.setFormData(type);
        }

        if (typeId > 0 && !type && isInitialCheck)
            this.toggleLoading(true, 0);
    }

    private async onSubmit(model: Forms.AdminAbstract.AbstractTypeData, body: any) {
        if (this.form)
            this.form.toggleProcessing(true);

        const result = await this.props.api.post(Api.endpoints.admin.abstractType.type.withUrlParams({ id: model.id }), {
            body: JSON.stringify(body),
        });

        if (!this._isMounted || !this.form)
            return;

        this.form.toggleProcessing(false);

        if (result.isSuccess) {
            this.props.notifySuccess(`Abstract type <strong>${model.shortName}</strong><br />has been successfully saved.`);
            this.props.goto(this.state.lastPath);
        }
        else {
            this.form.setFormErrors(M.Result.Result.errorsOrMessage(result), undefined, true);
        }
    }
}

export const EditType: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(EditTypeComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/editType/EditType.tsx